module.exports = __webpack_public_path__ + "media/src/images/feature-01-172c0f4310c568622c56e99cfd70e37f.png";